import axios from "axios";
import { dbPromise } from "../main";
import { Me } from "./me";

export class Sync {
    /**
     *
     * @param dados
     * @return {AxiosPromise<any>}
     */
    static autentica (dados) {
        return axios.put("https://cacm.centeralarm.com.br/send", dados);
    }

    /**
     *
     * @param key
     * @return {Promise<any>}
     */
    static get (key) {
        return new Promise(resolve => {
            dbPromise
                .then((db) => {
                    return db
                        .transaction("sync", "readwrite")
                        .objectStore("sync")
                        .get(key);
                })
                .then((dado) => resolve(dado))
                .catch((err) => console.error(err));
        });
    }

    static async syncAll (socket) {
        return new Promise((resolve, reject) => {
            if (window.navigator.onLine) {
                dbPromise
                    .then((db) => {
                        const tx = db.transaction("sync");

                        console.log("sync");

                        tx.objectStore("sync").iterateCursor(cursor => {
                            if (!cursor) return resolve();

                            Sync._send(cursor.value, cursor.key, socket)
                                .catch((err) => console.error(err));

                            cursor.continue();
                        });

                        tx.complete.then(() => resolve());
                    })
                    .catch((err) => reject(err));
            } else {
                reject(new Error("Sem Internet"));
            }
        });
        // }
    }

    /**
     *
     * @return {Promise<any>}
     */
    static getCursor () {
        return new Promise(resolve => {
            dbPromise
                .then((db) => {
                    return db
                        .transaction("sync", "readwrite")
                        .objectStore("sync")
                        .openCursor();
                })
                .then((cursor) => resolve(cursor))
                .catch((err) => console.error(err));
        });
    }

    static async syncOne (key, socket) {
        if (window.navigator.onLine) {
            let sync = await Sync.get(key);
            await Sync._send(sync, key, socket);
        }
    }

    static async _send (sync, key, socket) {
        try {
            let dados = await Me.get();

            let data = {
                body: sync,
                action: sync.action,
                id_funcionario: dados.id_funcionario
            };
            await Me.sync(data);
            await Sync.del(key);
            Sync.syncAll(socket)
                .catch((err) => console.error(err));
        } catch (e) {
            console.error(e);
        }
    }

    /**
     *
     * @param key
     * @return {Promise<any>}
     */
    static del (key) {
        return new Promise(resolve => {
            dbPromise
                .then((db) => {
                    return db
                        .transaction("sync", "readwrite")
                        .objectStore("sync")
                        .delete(key);
                })
                .then(() => resolve())
                .catch((err) => console.error(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise<any>}
     */
    static add (data) {
        return new Promise(resolve => {
            dbPromise
                .then((db) => {
                    return db
                        .transaction("sync", "readwrite")
                        .objectStore("sync")
                        .put(data);
                })
                .then((id) => resolve(id))
                .catch((err) => console.error(err));
        });
    }
}
